import JobPublicIcon from '@mui/icons-material/TaskOutlined';
import JobPublicList from './JobPublicList';
import JobPublicEdit from './JobPublicEdit';
import JobPublicCreate from './JobPublicCreate';

export default {
    list: JobPublicList,
    edit: JobPublicEdit,
    create: JobPublicCreate,
    icon: JobPublicIcon,
};
